import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { tap, map } from "rxjs/operators";
import { Store } from "@ngrx/store";
import { IAppState } from "src/app/store/states/app";
import { Observable, combineLatest } from "rxjs";
import { selectConnectionState } from "src/app/store/selectors/connection";

@Injectable()
export class ConnectionInterceptor implements HttpInterceptor {
  private connectionStatus: boolean = false;
  constructor(private _store: Store<IAppState>) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): any {
    combineLatest(this._store.select(selectConnectionState)).subscribe(
      ([connectionStatus]) => {
        this.connectionStatus = connectionStatus;
      },
    );

    if (this.connectionStatus) {
      return next.handle(request);
    } else {
      throw new Error("Internet Connection Required");
    }
  }
}
